/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CalculationTypeCountResourceTotal } from './calculationTypeCountResourceTotal';


export interface CalculationTypeCountResource { 
    type: string | null;
    total: CalculationTypeCountResourceTotal;
}

